import { FC } from 'react'
import { Dialog, Text } from '@plurall/elo-beta'

import styles from './Modal.module.scss'

type ModalProps = {
  onClose: () => void
}
const Modal: FC<ModalProps> = ({ onClose }) => (
  <Dialog clickOutside title='Como usar os dados de acesso' onClose={onClose}>
    <div className={styles['modal-paragraph']}>
      <Text size='t3' dimmed>
        • Para entrar no Plurall, você precisa utilizar o nome de usuário e senha entregues pela sua
        escola.
      </Text>
    </div>

    <div className={styles['modal-paragraph']}>
      <Text size='t3' dimmed>
        • Os dados de acessos são individuais, ou seja, cada aluno recebe o seu.
      </Text>
    </div>

    <div className={styles['modal-paragraph']}>
      <Text size='t3' dimmed>
        • Caso você não tenha recebido seus dados de acesso, ou esteja com dificuldades em
        utilizá-los, entre em contato com a coordenação da sua escola.
      </Text>
    </div>

    <Text size='t1' bold>
      Onde encontrar os dados de acesso
    </Text>

    <img
      className={styles['modal-img']}
      src={`${process.env.REACT_APP_ASSETS_URL}/images/plurall-login/plurall-screen-student.png`}
      alt='Instrução aluno'
    />
  </Dialog>
)

export default Modal
